import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":"","md4":"","lg3":""}},[_c(VLayout,{attrs:{"column":""}},[_c(VFlex,{attrs:{"ma-2":""}},[_c('FCCRaceDetails')],1)],1)],1),_c(VFlex,{attrs:{"xs12":"","md8":"","lg9":""}},[_c(VLayout,{attrs:{"column":""}},[_c(VFlex,{attrs:{"ma-2":""}},[_c('FCCRaceRuns')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }